import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { links, navItems } from '../data/site';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen]);
  return <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-sm border-b border-rule" data-id="element-88" data-mp="jmqer88l53m">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-89" data-mp="eje9359p79ny">
        <div className="h-20 flex items-center justify-between gap-8" data-id="element-90" data-mp="ekz4sy7r0yne">
          <a href="#top" className="font-serif text-lg sm:text-xl text-ink whitespace-nowrap hover:text-clay transition-colors duration-200" data-id="element-91" data-mp="9k1lgib05ykb">
            Craig Thomas
          </a>

          <nav aria-label="Primary" className="hidden lg:flex items-center gap-9" data-id="element-92" data-mp="1kyooefp9j0r9">
            {navItems.map(item => <a key={item.id} href={`#${item.id}`} className="text-[0.9375rem] text-ink-soft hover:text-ink whitespace-nowrap border-b border-transparent hover:border-clay pb-0.5 transition-colors duration-200" data-id="element-93" data-mp="9o7pzm47aqg0">
                {item.label}
              </a>)}
            <a href={links.booking} target="_blank" rel="noopener noreferrer" className="text-[0.9375rem] font-medium text-paper bg-ink px-5 py-2.5 rounded-md whitespace-nowrap hover:bg-clay transition-colors duration-200" data-id="element-94" data-mp="3n3ma4ooncyg4">
              Let’s Talk
            </a>
          </nav>

          <button type="button" onClick={() => setIsOpen(open => !open)} aria-expanded={isOpen} aria-controls="mobile-nav" aria-label={isOpen ? 'Close menu' : 'Open menu'} className="lg:hidden -mr-2 p-2 text-ink hover:text-clay transition-colors duration-200" data-id="element-95" data-mp="5ofkjia3t0ev">
            {isOpen ? <XIcon size={22} data-id="element-96" data-mp="2wcq7cdrvrk8k" /> : <MenuIcon size={22} data-id="element-97" data-mp="2wb58ibyj9f4w" />}
          </button>
        </div>
      </div>

      {isOpen && <nav id="mobile-nav" aria-label="Primary mobile" className="lg:hidden border-t border-rule bg-paper" data-id="element-98" data-mp="3b01k2izstaa9">
          <div className="max-w-content mx-auto px-6 py-4 flex flex-col" data-id="element-99" data-mp="364cgm4knr98o">
            {navItems.map(item => <a key={item.id} href={`#${item.id}`} onClick={() => setIsOpen(false)} className="py-3 text-base text-ink-soft hover:text-ink border-b border-rule last:border-0 transition-colors duration-200" data-id="element-100" data-mp="2ddkmrdr2ewoi">
                {item.label}
              </a>)}
            <a href={links.booking} target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="mt-4 mb-1 text-center text-base font-medium text-paper bg-ink px-5 py-3 rounded-md hover:bg-clay transition-colors duration-200" data-id="element-101" data-mp="7it301cwaegl">
              Let’s Talk
            </a>
          </div>
        </nav>}
    </header>;
}